import Joi from "joi";

export const createFamilySchema = Joi.object({
  name: Joi.string()
    .pattern(/^[A-Za-z\s]+$/)
    .min(3)
    .max(100)
    .required()
    .messages({
      "string.empty": "Name is required.",
      "string.pattern.base": "Name should only contain alphabets and spaces.",
      "string.min": "Name should be at least 3 characters long.",
      "string.max": "Name cannot exceed 100 characters.",
    }),
  relationship: Joi.string()
    .min(1)
    .max(50)
    .required()
    .messages({
      "string.empty": "Relationship is required.",
      "string.min": "Relationship must have at least 1 character.",
      "string.max": "Relationship cannot exceed 50 characters.",
    }),
  date_of_birth: Joi.date()
    .less("now")
    .required()
    .messages({
      "date.base": "Date of birth must be a valid date.",
      "date.less": "Date of birth cannot be in the future.",
    }),
  is_depend_on_family: Joi.boolean()
    .required()
    .messages({
      "any.required": "Is dependent on family is required.",
    }),
  contact_no: Joi.string()
    .pattern(/^[6-9]\d{9}$/)
    .min(10)
    .max(10)
    .required()
    .messages({
      "string.empty": "Contact number is required.",
      "string.pattern.base": "Contact number must start with 6-9 and contain exactly 10 digits.",
      "string.min": "Contact number must be exactly 10 digits.",
      "string.max": "Contact number must be exactly 10 digits.",
    }),
  address: Joi.string()
    .max(255)
    .required()
    .messages({
      "string.empty": "Address is required.",
      "string.max": "Address cannot exceed 255 characters.",
    }),

});
